import React, { useState, useEffect } from "react";

import Styles from "./card.module.css";
import trainer1 from "../../Assets/homepage/window.svg";
import trainer2 from "../../Assets/homepage/window.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import axios from "axios";

function Card() {
  const [Trainer, setTrainer] = useState([
    {
      Avtar: trainer2,
      Name: "React",
      Details: "Full frontend with react",
      Fees: "₹1200",
      rating: 4,
    },
    {
      Avtar: trainer1,
      Name: "web3.0",
      Details: "Cardio Trainer/Nutrionist",
      Fees: "₹1000",
      rating: 5,
    },
    {
      Avtar: trainer1,
      Name: "Node.js",
      Details: "Cardio Trainer/Nutrionist",
      Fees: "₹1500",
      rating: 4,
    },
    {
      Avtar: trainer2,
      Name: "Surya Singh",
      Details: "Cardio Trainer/Nutrionist",
      Fees: "₹1000",
      rating: 3,
    },
  ]);
  const rating = 3;
  useEffect(() => {
    axios
      .get("https://edflixforus.herokuapp.com/course")
      .then((res) => setTrainer(res.data));
  }, []);
  return Trainer.map((train) => (
    <div className={Styles.trainerCard}>
      <img src={trainer1} alt="trainer img" />
      <div className={Styles.fullDetails}>
        <div className={Styles.details}>
          <h1>{train.title}</h1>
          <h6>{train.description}</h6>
        </div>
        <div className={Styles.details}>
          <h1 className={Styles.Fees}>{500}</h1>
          <div className={Styles.rating}>
            <FontAwesomeIcon
              icon={faStar}
              className={rating >= 1 ? Styles.iconYellow : Styles.iconGrey}
            />
            <FontAwesomeIcon
              icon={faStar}
              className={rating >= 2 ? Styles.iconYellow : Styles.iconGrey}
            />
            <FontAwesomeIcon
              icon={faStar}
              className={rating >= 3 ? Styles.iconYellow : Styles.iconGrey}
            />
            <FontAwesomeIcon
              icon={faStar}
              className={rating >= 4 ? Styles.iconYellow : Styles.iconGrey}
            />
            <FontAwesomeIcon
              icon={faStar}
              className={rating >= 5 ? Styles.iconYellow : Styles.iconGrey}
            />
            <h6>{4}/5</h6>
          </div>
        </div>

        <div className={Styles.button}>
          <button className={Styles.btn} style={{ background: "#49C016" }}>
            Get Trial
          </button>
          <Link to={`/coursedetails/${train._id}`}>
            <button className={Styles.btn}>Know more</button>
          </Link>
        </div>
      </div>
    </div>
  ));
}

export default Card;
